import { PipesModule } from './../../pipes/pipes.module';
import { SwiperModule } from 'angular2-useful-swiper';
import { HomeComponent } from './home.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { routing } from './home.routing';
import { ProductsComponent } from '@app/components/products/products.component';
import { MobileComponent } from '@app/components/mobile/mobile.component';
import { MenusComponent } from '@app/components/menus/menus.component';
import { AbsolutePathModule } from '@app/pipes/absolute-path/absolute-path.module';
import { LazyLoadModule } from '@app/directives/app-lazy-load.module';
import { PanierModule } from '../panier/panier.module';
import { HelpycurrencyModule } from '@app/pipes/helpycurrency/helpycurrency.module';
@NgModule({
    imports: [
        CommonModule,
        routing,
        SwiperModule,
        AbsolutePathModule,
        LazyLoadModule,
        PipesModule,
        PanierModule,
        HelpycurrencyModule
    ],
    declarations: [
        HomeComponent,
        ProductsComponent,
        MenusComponent,
        MobileComponent
    ],
    exports: [
    ],
    providers:[ ]
})

export class HomeModule {}
